
import React, { useState, useEffect } from 'react';
import { Dropdown, Checkbox, TextInput, Button } from 'carbon-components-react';
import { AddAlt16 } from '@carbon/icons-react';
import i18n from "../../i18n";
import "global.scss";
require("./_recommend-resource.scss");



export const RecommendResource = (props) => {
  let user = JSON.parse(localStorage.getItem('user'));
  const rowsArray = [];
  // const [numberOfTasks, setNumberOfTasks] = useState(1);
  const [numberOfAutomata, setNumberOfAutomata] = useState(1);

  //const AddTask = i18n.t('manageschedule.AddTask');
  //const SaveTask = i18n.t('manageschedule.SaveTask');
  const Task = i18n.t('manageschedule.Task');
  // function renderNewAutomata() {
  //     let count = props.currentAutomata.length;
  //     count = count + 1;
  //     setNumberOfAutomata(count)
  // }
  useEffect(() => {

  }, [])

  if (user !== null && user.access_token !== null) {
    // return (
    //   <>
    //     <div className="add-duration">
    //        <div className="bx--col bx--col-sm-4">
    //       <div className="bx--grid">
    //         {Array.apply(null, { length: props.tasksArray.length }).map((e, i) => (

    //           <div className="bx--row task-name carbon-display-Semibold-16">

    //               <div className="task-id">
    //                 Task {i + 1}
    //               </div>
    //             {Array.apply(null, { length: props.tasksArray[i].automataArray.length }).map((e, j) => (
    //               <div className="bx--row automata">
    //                 <div className="bx--col bx--col-sm-4 carbon-display-Regular-14">
    //                   {props.tasksArray[i].automataArray.length > 0 && props.tasksArray[i].automataArray[j] && props.tasksArray[i].automataArray[j].key.length > 20 ? props.tasksArray[i].automataArray[j].key.substr(0, 16) + '\n' + props.tasksArray[i].automataArray[j].key.substr(17, 23) : props.tasksArray[i].automataArray[j].key}
    //                   {/* Automata {j} */}
    //                 </div>
    //                 {/* {Array.apply(null, { length: props.tasksArray[i].automataArray[j].resourceDropdown.length}).map((dropdown) => ( */}
    //                 {props.tasksArray[i].automataArray[j].resourceDropdown && props.tasksArray[i].automataArray[j].resourceDropdown.forEach(function(element,index){
    //                    let taskobject = {};
    //                    taskobject.key = element;
    //                    taskobject.id = element + index;
    //                    rowsArray.push(taskobject);

    //                 })
    //               }
    //                   <div className="bx--col bx--col-sm-4">
    //                   <Dropdown
    //                     required
    //                     ariaLabel="RecommendResource"
    //                     id="RecommendResource"
    //                     items={rowsArray}
    //                     titleText="RecommendResource"
    //                     label="Select"
    //                     onChange={({ selectedItem }) => props.ResourceNameChange(selectedItem, i, j)}
    //                     selectedItem={props.tasksArray[i].automataArray[j].resourceName}
    //                     itemToString={(item) => (item ? item.key : '')} >
    //                   </Dropdown>
    //                 </div>
    //               </div>

    //             ))}
    //           </div>
    //         ))}
    //         </div>
    //       </div>
    //     </div>
    //   </>
    // )
    return (
      <>
        <div className="add-duration">
          <div className="bx--grid">
            {Array.apply(null, { length: props.tasksArray.length }).map((e, i) => (

              <div className="bx--row task-name carbon-display-Semibold-16">
                <div className="bx--col bx--col-sm-4">
                  <div className="task-id">
                  {Task} {i + 1}
                  </div>
                </div>
                {Array.apply(null, { length: props.tasksArray[i].automataArray.length }).map((e, j) => (
                  <div className="bx--row automata">
                    <div className="bx--col bx--col-sm-4 carbon-display-Regular-14">
                      {props.tasksArray[i].automataArray.length > 0 && props.tasksArray[i].automataArray[j] && props.tasksArray[i].automataArray[j].key.length > 20 ? props.tasksArray[i].automataArray[j].key.substr(0, 16) + '\n' + props.tasksArray[i].automataArray[j].key.substr(17, 23) : props.tasksArray[i].automataArray[j].key}
                      {/* Automata {j} */}
                    </div>
                    {props.tasksArray[i].automataArray[j].resourceDropdown && props.tasksArray[i].automataArray[j].resourceDropdown.forEach(function (element, index) {
                      let taskobject = {};
                      taskobject.key = element;
                      taskobject.id = element + index;
                      rowsArray.push(taskobject);

                    })
                    }
                    <div className="bx--col bx--col-sm-4">
                      <Dropdown
                        disabled={props.review}
                        className="recommended-dropdown"
                        required
                        ariaLabel="RecommendResource"
                        id="RecommendResource"
                        items={rowsArray}
                        titleText={i18n.t('editScheduleRecommendation.recommendResource')}
                        label="Select"
                        onChange={({ selectedItem }) => props.ResourceNameChange(selectedItem, i, j)}
                        selectedItem={props.tasksArray[i].automataArray[j].resourceName}
                        itemToString={(item) => (item ? item.key : '')} >
                      </Dropdown>
                    </div>
                    <div className="bx--col bx--col-sm-4 completion-box">
                      {/* <TextInput
                                    id={"delay" + i}
                                    invalidText="A valid value is required"
                                    placeholder="Eg: 10"
                                    labelText="Post completion delay (in secs)"
                                    value={props.tasksArray[i].automataArray[j].time}
                                    // value={props.timeDelay}
                                    onChange={(e) => props.handleTimeDelay(e,i,j)}
                                /> */}
                    </div>
                    <div className="bx--col bx--col-sm-4 action-button">
                      {/* <Button kind="ghost" renderIcon={AddAlt16} onClick={props.renderNewAutomata}></Button> */}
                    </div>
                  </div>

                ))}
              </div>
            ))}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div>
        <h2>{i18n.t('editScheduleRecommendation.please')}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {i18n.t('editScheduleRecommendation.signup')} </a> </h2>
      </div>
    );
  }

}